import * as React from "react";
const ArrowSquareOut = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", fill: "currentColor", ...props },
    React.createElement("path", { fill: "none", d: "M0 0h256v256H0z" }),
    React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 24, d: "m136 120 80-80M216 104l-.01-63.99L152 40M184 140v68a8 8 0 0 1-8 8H48a8 8 0 0 1-8-8V80a8 8 0 0 1 8-8h68" })));
export default ArrowSquareOut;
